<template>
  <div class="membership_manage">
    <div class="hgroup">
      <h2>MEMBERS MANAGEMENT</h2>
      <p>Check accounts awaiting approval and your members.</p>
    </div>
    <div class="boxType2">
      <p class="tab1">
        <router-link :to="{ name: 'ManageApproval' }" active-class="on">
          {{ $t('manageMember.approvalPending') }}
        </router-link>
        <router-link :to="{ name: 'ManageUser' }" active-class="on">
          {{ $t('manageMember.manageMember') }}
        </router-link>
        <router-link :to="{ name: 'ManageReport' }" active-class="on">
          URL management
        </router-link>
      </p>

      <component :is="menuName"
        :menuName="menuName" />
    </div>
  </div>
</template>

<script>
import ManageApproval from './ManageApproval'
import ManageUser from './ManageUser'
import ManageReport from './ManageReport'

export default {
  name: 'AdminHome',
  components: {
    ManageApproval,
    ManageUser,
    ManageReport
  },
  data () {
    return {
      menuName: null
    }
  },
  created () {
    this.setMenuName()
  },
  watch: {
    '$route' (to, from) {
      this.setMenuName()
    }
  },
  methods: {
    setMenuName () {
      this.menuName = this.$route.name
    }
  }
}
</script>

<style>
.membership_manage .hgroup{ width: 1200px; margin: 0 auto;}
.searchMember  {padding:10px 0; border-bottom:1px solid #ccc;}
.searchMember * {font-size:13px;}
.searchMember label { font-weight:bold; margin:0 10px; line-height:30px; vertical-align:top;}
.searchMember .select select, .searchMember input {font-size:13px; height:30px; vertical-align:middle;}
.searchMember .select, .searchMember input {width:200px;}
.searchMember .btn_2 {height:28px; font-size:13px; line-height:28px; vertical-align:middle;}

.memberlist {position:relative;}
.memberlist * {font-size:13px; line-height:34px;}
.memberlist  p {position:absolute; top:-38px; right:0; text-align:right;}
.memberlist th {text-align:center; }
.memberlist td {text-align:center; border-top:1px solid #ddd;}
.memberlist td:first-child {text-align:center;}
.memberlist tr:nth-child(even) td {background:#f8f8f8}
.memberlist .approval_btn{ background-color: #294f75; color: #fff; border-radius: 4px; padding: 0 5px; line-height: 1.9;}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminHome.vue